import React, { useEffect, useState, useMemo } from "react";

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../../../../_metronic/_partials/controls";
import * as businessesCrud from '../../../_redux/businesses/businessesCrud';
import * as usersCrud from "../../../_redux/users/usersCrud";
import helper_funcs from "../../../../helper_funcs.js";
import {
  Modal,
} from 'react-bootstrap'
import { useSelector } from "react-redux";
import _ from 'lodash';
import * as categoriesCrud from '../../../_redux/categories/categoriesCrud';
import * as countriesCrud from '../../../_redux/countries/countriesCrud';
import * as citiesCrud from '../../../_redux/cities/citiesCrud';
import Select, { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { STANDARD_LANGUAGES } from '../../../languages';
import { AddCategoryModal } from '../../categories/AddCategoryModal';
// Helper to safely check if string is valid JSON object/array
const isValidJSON = (str) => {
  if (!str || typeof str !== "string") return false;
  try {
    const parsed = JSON.parse(str);
    return parsed !== null && typeof parsed === "object";
  } catch (e) {
    return false;
  }
};

const toolsIsValidJSON = isValidJSON;

const getSocialFieldValue = (directVal, socialMediaVal, platformKey) => {
  if (directVal) {
    if (typeof directVal === "string") {
      try {
        const parsed = JSON.parse(directVal);
        if (parsed && typeof parsed === "object") {
          if (platformKey && parsed[platformKey]) {
            const platformVal = parsed[platformKey];
            return Array.isArray(platformVal) ? platformVal.join(", ") : String(platformVal);
          }
        } else {
          return directVal;
        }
      } catch (e) {
        return directVal;
      }
    } else if (Array.isArray(directVal)) {
      return directVal.join(", ");
    } else if (typeof directVal !== "object") {
      return String(directVal);
    }
  }

  if (socialMediaVal) {
    if (Array.isArray(socialMediaVal)) {
      return socialMediaVal.join(", ");
    }
    if (typeof socialMediaVal === "string") {
      return socialMediaVal;
    }
  }
  return "";
};

// Validation schema
const BusinessEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Minimum 2 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Name is required"),
  userid: Yup.string().test("is-create", "User is required", function (value) {
    const isCreate = !this.parent.id;
    if (isCreate && !value) {
      return false;
    }
    return true;
  }),
  business_email: Yup.string()
    .email("Invalid email format")
    .test("is-create-email-req", "Email is required", function (value) {
      const isCreate = !this.parent.id;
      if (isCreate && !value) {
        return false;
      }
      return true;
    }),
});

export function EditBusinessForm({
  business,
  btnRef,
  saveBusiness,
  businessBasicPage,
  formikRef,
}) {
  const { user } = useSelector(state => state.auth);
  const [showimgmodal, showImgModal] = useState(false);
  const [modalimagesrc, modalImageSrc] = useState('');
  const [allCategories, setAllCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categorySearchInput, setCategorySearchInput] = useState('');
  const [selectedSubcategories, setSelectedSubcategories] = useState([]);
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [addressSearchText, setAddressSearchText] = useState('');
  const [addressSearchResults, setAddressSearchResults] = useState([]);
  const [isSearchingAddress, setIsSearchingAddress] = useState(false);
  const [addressSearchError, setAddressSearchError] = useState('');

  const handleAddressSearch = async (searchTerm) => {
    const term = searchTerm || addressSearchText;
    if (!term || !term.trim()) return;
    setIsSearchingAddress(true);
    setAddressSearchError('');
    try {
      const res = await businessesCrud.geocodeAddress(term.trim());
      if (res.data && res.data.status && res.data.results && res.data.results.length > 0) {
        setAddressSearchResults(res.data.results);
      } else {
        setAddressSearchResults([]);
        setAddressSearchError(res.data?.message || 'No address matches found.');
      }
    } catch (err) {
      console.error('Error searching address:', err);
      setAddressSearchError('Failed to search address. Please try again.');
    } finally {
      setIsSearchingAddress(false);
    }
  };

  useEffect(() => {
    if (!business?.id) {
      setLoadingUsers(true);
      usersCrud
        .findUsers({
          pageNumber: 1,
          pageSize: 1000,
          filter: {},
          sortField: "name",
          sortOrder: "asc",
        })
        .then((res) => {
          if (res.data && res.data.entities) {
            setUsers(res.data.entities);
          }
          setLoadingUsers(false);
        })
        .catch((err) => {
          console.error("Error fetching users:", err);
          setLoadingUsers(false);
        });
    }
  }, [business?.id]);

  const userOptions = useMemo(() => {
    return users.map((u) => ({
      value: u.userid || u.id,
      label: `${u.name} (${u.email})`,
    }));
  }, [users]);

  useEffect(() => {
    categoriesCrud.getAllCategories().then(res => {
      if (res.data && res.data.data) {
        setAllCategories(res.data.data);
      }
    }).catch(err => console.log(err));

    countriesCrud.getAllCountries().then(res => {
      if (res.data && res.data.data) {
        setCountries(res.data.data);
      }
    }).catch(err => console.log(err));
  }, []);

  const [selectedOriginCountries, setSelectedOriginCountries] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);

  useEffect(() => {
    if (business) {
      let categoryIds = [];
      if (business.category_id) {
        categoryIds = String(business.category_id).replace(/[\[\]]/g, '').split(',').map(id => id.trim()).filter(Boolean);
      } else if (Array.isArray(business.categories) && business.categories.length > 0) {
        categoryIds = business.categories.map(c => String(c.id || c.category_id || c.value)).filter(Boolean);
      }
      setSelectedCategories(categoryIds);

      const subCategories = business.sub_category || [];
      setSelectedSubcategories(subCategories.map(sc => ({
        id: sc.sub_category_id || sc.id,
        name: sc.name
      })));

      if (business.country_id) {
        citiesCrud.getCitiesByCountryId(business.country_id).then(res => {
          if (res.data && res.data.data) {
            setCities(res.data.data);
          }
        }).catch(err => console.log(err));
      }

      // Parse origin_countries
      let originList = [];
      if (business.origin_countries) {
        if (typeof business.origin_countries === 'string' && isValidJSON(business.origin_countries)) {
          try { originList = JSON.parse(business.origin_countries); } catch (e) {}
        } else if (Array.isArray(business.origin_countries)) {
          originList = business.origin_countries;
        } else if (typeof business.origin_countries === 'string') {
          originList = business.origin_countries.replace(/[\[\]"]/g, '').split(',').map(s => s.trim()).filter(Boolean);
        }
      }
      setSelectedOriginCountries(Array.isArray(originList) ? originList : []);

      // Parse languages
      let langList = [];
      if (business.languages) {
        if (typeof business.languages === 'string' && isValidJSON(business.languages)) {
          try { langList = JSON.parse(business.languages); } catch (e) {}
        } else if (Array.isArray(business.languages)) {
          langList = business.languages;
        } else if (typeof business.languages === 'string') {
          langList = business.languages.replace(/[\[\]"]/g, '').split(',').map(s => s.trim()).filter(Boolean);
        }
      }
      setSelectedLanguages(Array.isArray(langList) ? langList : []);
    }
  }, [business]);

  // Custom option component with checkbox
  const CheckboxOption = (props) => {
    return (
      <components.Option {...props}>
        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: '10px', cursor: 'pointer', pointerEvents: 'none' }}
          />
          <span>{props.label}</span>
        </div>
      </components.Option>
    );
  };

  const handleCategorySelectChange = (selectedOptions) => {
    const newCatIds = selectedOptions ? selectedOptions.map(opt => String(opt.value)) : [];
    setSelectedCategories(newCatIds);

    // Filter out subcategories whose category is no longer selected
    const remainingCats = allCategories.filter(c => newCatIds.includes(String(c.id)));
    const allowedSubcatIds = [];
    remainingCats.forEach(c => {
      if (c.sub_category) {
        c.sub_category.forEach(sc => allowedSubcatIds.push(sc.id));
      }
    });
    setSelectedSubcategories(prev => prev.filter(sc => allowedSubcatIds.includes(sc.id)));
  };

  const handleSubcategorySelectChange = (selectedOptions) => {
    const newSubcats = selectedOptions ? selectedOptions.map(opt => ({ id: opt.value, name: opt.label })) : [];
    setSelectedSubcategories(newSubcats);
  };

  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [categoryModalInitialName, setCategoryModalInitialName] = useState("");

  const handleCategoryFromModal = ({ id, name }) => {
    if (!id) return;
    setAllCategories((prev) => {
      if (prev.some((c) => String(c.id) === String(id))) return prev;
      return [
        ...prev,
        { id: String(id), name, status: "active", approval_status: "approved" },
      ];
    });
    setSelectedCategories((prev) => [...new Set([...prev, String(id)])]);
  };


  const categoryOptions = useMemo(() => {
    const opts = allCategories.map(cat => ({
      value: String(cat.id),
      label: cat.name
    }));
    if (Array.isArray(business?.categories)) {
      business.categories.forEach(c => {
        const idStr = String(c.id || c.category_id || c.value);
        if (idStr && !opts.some(o => o.value === idStr)) {
          opts.push({ value: idStr, label: c.name || `Category #${idStr}` });
        }
      });
    }
    return opts;
  }, [allCategories, business?.categories]);

  const selectedCategoryOptions = useMemo(() => {
    return categoryOptions.filter(opt => selectedCategories.includes(opt.value));
  }, [categoryOptions, selectedCategories]);

  const availableSubcategories = useMemo(() => {
    return allCategories
      .filter(cat => selectedCategories.includes(String(cat.id)))
      .reduce((acc, cat) => {
        if (cat.sub_category) {
          cat.sub_category.forEach(sub => {
            if (!acc.some(opt => opt.value === sub.id)) {
              acc.push({
                value: sub.id,
                label: `${sub.name} (${cat.name})`
              });
            }
          });
        }
        return acc;
      }, []);
  }, [allCategories, selectedCategories]);

  const selectedSubcategoryOptions = useMemo(() => {
    return availableSubcategories.filter(opt =>
      selectedSubcategories.some(sc => sc.id === opt.value)
    );
  }, [availableSubcategories, selectedSubcategories]);

  const countryOptions = useMemo(() => {
    return countries.map(c => ({
      value: c.id,
      label: c.name
    }));
  }, [countries]);

  const cityOptions = useMemo(() => {
    return cities.map(c => ({
      value: c.id,
      label: c.name
    }));
  }, [cities]);

  /* checkbox start  */
  const [name_checkbox, setName_checkbox] = useState(false);
  const [phone_checkbox, setPhone_checkbox] = useState(false);
  const [tagline_checkbox, setTagline_checkbox] = useState(false);
  const [address_checkbox, setAddress_checkbox] = useState(false);
  const [facebook_checkbox, setFacebook_checkbox] = useState(false);
  const [area_code_checkbox, setAreaCode_checkbox] = useState(false);
  const [product_detail_checkbox, setProductDetail_checkbox] = useState(false);
  const [business_images, setBusinessImages_checkbox] = useState([]);
  const [business_logo_image, setBusinessLogoImage_checkbox] = useState(false);
  /* checkbox end */


  /* reported list  */
  const [is_report, setIsReport] = useState(false);
  const [rep_name, setRepName] = useState(false);
  const [rep_phone, setRepPhone] = useState(false);
  const [rep_logo, setRepLogo] = useState(false);
  const [rep_tagline, setRepTagline] = useState(false);
  const [rep_address, setRepAddress] = useState(false);
  const [rep_facebook, setRepFacebook] = useState(false);
  const [rep_areacode, setRepAreaCode] = useState(false);
  const [rep_product_detail, setRepProductDetail] = useState(false);

  /* checkbox end */

  const sampleFunction = async (event, val) => {
    event.stopPropagation()
    showImgModal(val)
    modalImageSrc('')
  };
  // var userid = "";
  // var username = "";
  // if (user.userData.userid) { userid = user.userData.userid; }
  // if (user.userData.name) { username = user.userData.name; }

  const userobject = user.userData;
  var superadmin = true;
  if (userobject.admin_role && userobject.admin_role !== 'superadmin' && userobject.is_admin) { superadmin = false; }

  var [purchasedvalue, setpurchsedstatus] = useState(false);
  var [isloading, setIsLoading] = useState(false);

  const call_report_image_array = (imageid) => {
    let business_image_arr = business_images
    var index = business_image_arr.indexOf(imageid);
    if (index > -1) {
      business_image_arr.splice(index, 1);
    }
    else {
      business_image_arr.push(imageid)
    }
    setBusinessImages_checkbox(business_image_arr)
  }

  const onPurchasedChange = (value) => {
    setpurchsedstatus(value)
  }

  const imageModal = async (event, src) => {
    modalImageSrc(src)
    showImgModal(true)
  }

  const fileSelected = async (event, item, setFieldValue) => {
    document.getElementById('icon_updated').click();
    document.getElementById('icon_updated').onchange = async (e) => {
      if (!item.userid) {
        alert("Please select the Owner User first before uploading the icon.");
        return;
      }
      setIsLoading(true)
      if (item.id && !(item.logo === 'null' || item.logo == null || item.logo === '')) {
        await helper_funcs.deleteImage(item.logo)
      }
      const upload = await helper_funcs.uploadimage(e, item, 'icon_updated')
      if (upload === 'error') {
        setIsLoading(false);
        return alert("Please choose a file to upload first.");
      }
      var promise = upload.promise();

      promise.then(
        async function (data) {
          //data.key gives file name and location give full path
          if (item.id) {
            const response = await businessesCrud.updateLogo(item.id, data.key);
            if (response) {
              businessBasicPage();
              setIsLoading(false);
            }
          } else {
            setFieldValue("logo", data.key);
            setIsLoading(false);
          }
        },
        function (err) {
          setIsLoading(false);
          return err;
        }
      );
    }
  }

  useEffect(() => {
    if (business.is_purchased) {
      setIsLoading(false)
      setpurchsedstatus(business.is_purchased)
    }
    if (business.report_business != null) {
      let report_fields = JSON.parse(business.report_business.report_fields)
      if (business.report_business.is_report) { setIsReport(business.report_business.is_report) }
      if (report_fields.name) { setRepName(report_fields.name) }
      if (report_fields.phone) { setRepPhone(report_fields.phone) }
      if (report_fields.logo) { setRepLogo(report_fields.logo) }
      if (report_fields.tagline) { setRepTagline(report_fields.tagline) }
      if (report_fields.address) { setRepAddress(report_fields.address) }
      if (report_fields.facebook) { setRepFacebook(report_fields.facebook) }
      if (report_fields.area_code) { setRepAreaCode(report_fields.area_code) }
      if (report_fields.product_detail) { setRepProductDetail(report_fields.product_detail) }
    }

  }, [business]);

  return (
    <>
      <Modal centered show={showimgmodal} onHide={() => showImgModal(false)}>
        <Modal.Header style={{ display: "grid", gridTemplateColumns: "85% 15%" }} >
          <Modal.Title>Business Image </Modal.Title>
          <button type="button" className="btn btn-secondary" onClick={(event) => sampleFunction(event, false)} >Close</button>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12 form-group">
              {(modalimagesrc === '') ? <></> :
                <img alt="modalimage" className="modal-image modal-content" src={modalimagesrc} />
              }
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Formik
        innerRef={formikRef}
        enableReinitialize={true}
        initialValues={{
          ...business,
          name: business?.name ?? "",
          phone: business?.phone ?? "",
          tagline: business?.tagline ?? "",
          area_code: business?.area_code ?? "",
          latitude: business?.latitude ?? "",
          longitude: business?.longitude ?? "",
          show_exact_address: (business?.show_exact_address !== undefined && business?.show_exact_address !== null)
            ? (business.show_exact_address === true || business.show_exact_address === 'true' || business.show_exact_address === 1 || business.show_exact_address === '1')
            : true,
          zip_code: business?.zip_code ?? "",
          facebook: getSocialFieldValue(business?.facebook, business?.social_media?.facebook, 'facebook'),
          website: business?.website ?? "",
          linkedin: getSocialFieldValue(business?.linkedin, business?.social_media?.linkedin, 'linkedin'),
          instagram: getSocialFieldValue(business?.instagram, business?.social_media?.instagram, 'instagram'),
          tiktok: getSocialFieldValue(business?.tiktok, business?.social_media?.tiktok, 'tiktok'),
          x: getSocialFieldValue(business?.x, business?.social_media?.x, 'x'),
          address: business?.address ?? "",
          country_id: business?.country_id ?? null,
          city_id: business?.city_id ?? null,
          product_details: business?.product_details ?? "",
          business_email: business?.business_email ?? "",
          user_grace_period_start: business?.user_grace_period_start ? new Date(business.user_grace_period_start).toISOString().slice(0, 10) : "",
          user_grace_period_end: business?.user_grace_period_end ? new Date(business.user_grace_period_end).toISOString().slice(0, 10) : "",
        }}
        validationSchema={BusinessEditSchema}
        onSubmit={(values) => {
          let newvalues = _.cloneDeep(values)
          newvalues.is_purchased = purchasedvalue;
          newvalues.name_checkbox = name_checkbox;
          newvalues.phone_checkbox = phone_checkbox;
          newvalues.tagline_checkbox = tagline_checkbox;
          newvalues.address_checkbox = address_checkbox;
          newvalues.facebook_checkbox = facebook_checkbox;
          newvalues.area_code_checkbox = area_code_checkbox;
          newvalues.product_detail_checkbox = product_detail_checkbox;
          newvalues.business_logo_image_rep = business_logo_image;
          newvalues.business_images_rep = business_images;
          newvalues.category_id = selectedCategories;
          newvalues.origin_countries = selectedOriginCountries;
          newvalues.languages = selectedLanguages;
          newvalues.show_exact_address = values.show_exact_address;
          // newvalues.sub_category = selectedSubcategories;
          saveBusiness(newvalues);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <>
            <Form className="form form-label-right">
              {/* Business Overview Header Banner for Existing Business */}
              {business?.id && (
                <div className="row mb-6">
                  {/* Status Card */}
                  <div className="col-sm-6 col-lg-3 mb-3 mb-lg-0">
                    <div
                      className="card card-custom p-4 h-100 shadow-xs"
                      style={{
                        backgroundColor: "#ffffff",
                        borderRadius: "10px",
                        border: "1px solid #eef0f8",
                      }}
                    >
                      <span className="text-muted font-size-xs text-uppercase font-weight-bolder mb-2 d-flex align-items-center">
                        <i className="fa fa-info-circle text-muted mr-2 font-size-xs"></i>
                        Status
                      </span>
                      <div className="d-flex align-items-center" style={{ minHeight: "32px" }}>
                        <span
                          className={`badge font-weight-bolder px-3 py-2 ${
                            business.status === "approved"
                              ? "badge-light-success text-success"
                              : business.status === "pending"
                              ? "badge-light-warning text-warning"
                              : business.status === "rejected"
                              ? "badge-light-danger text-danger"
                              : "badge-light-secondary"
                          }`}
                          style={{ fontSize: "12px", letterSpacing: "0.5px" }}
                        >
                          {business.status ? business.status.toUpperCase() : "PENDING"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Approved By Card */}
                  <div className="col-sm-6 col-lg-3 mb-3 mb-lg-0">
                    <div
                      className="card card-custom p-4 h-100 shadow-xs"
                      style={{
                        backgroundColor: "#ffffff",
                        borderRadius: "10px",
                        border: "1px solid #eef0f8",
                      }}
                    >
                      <span className="text-muted font-size-xs text-uppercase font-weight-bolder mb-2 d-flex align-items-center">
                        <i className="fa fa-user-check text-muted mr-2 font-size-xs"></i>
                        Approved By
                      </span>
                      <div className="d-flex align-items-center" style={{ minHeight: "32px" }}>
                        {business.approved_by_name ? (
                          <span
                            className="badge font-weight-bolder px-3 py-2 text-primary"
                            style={{
                              backgroundColor: "#e8f4fd",
                              fontSize: "12px",
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                          >
                            <i className="fa fa-user-shield mr-2 font-size-xs text-primary"></i>
                            {business.approved_by_name}
                          </span>
                        ) : (
                          <span className="text-muted font-weight-bold pl-1 font-size-sm">-</span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Tier / Type Card */}
                  <div className="col-sm-6 col-lg-3 mb-3 mb-lg-0">
                    <div
                      className="card card-custom p-4 h-100 shadow-xs"
                      style={{
                        backgroundColor: "#ffffff",
                        borderRadius: "10px",
                        border: "1px solid #eef0f8",
                      }}
                    >
                      <span className="text-muted font-size-xs text-uppercase font-weight-bolder mb-2 d-flex align-items-center">
                        <i className="fa fa-gem text-muted mr-2 font-size-xs"></i>
                        Tier / Type
                      </span>
                      <div className="d-flex align-items-center" style={{ minHeight: "32px" }}>
                        {business.is_purchased ? (
                          <span
                            className="badge font-weight-bolder"
                            style={{
                              backgroundColor: "#fff4de",
                              color: "#b45309",
                              border: "1px solid #fcd34d",
                              padding: "6px 12px",
                              fontSize: "12px",
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                          >
                            <i className="fa fa-crown mr-1" style={{ color: "#d97706", fontSize: "12px" }}></i>
                            Premium Business
                          </span>
                        ) : (
                          <span
                            className="badge badge-light font-weight-bold text-muted border px-3 py-2"
                            style={{ fontSize: "12px" }}
                          >
                            Standard / Free
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Expiry Card */}
                  <div className="col-sm-6 col-lg-3">
                    <div
                      className="card card-custom p-4 h-100 shadow-xs"
                      style={{
                        backgroundColor: "#ffffff",
                        borderRadius: "10px",
                        border: "1px solid #eef0f8",
                      }}
                    >
                      <span className="text-muted font-size-xs text-uppercase font-weight-bolder mb-2 d-flex align-items-center">
                        <i className="fa fa-calendar-alt text-muted mr-2 font-size-xs"></i>
                        {business.is_purchased ? "Premium Expiry" : "Plan Expiry"}
                      </span>
                      <div className="d-flex align-items-center" style={{ minHeight: "32px" }}>
                        {business.is_purchased && business.expiry ? (
                          <span
                            className="font-weight-bolder text-warning font-size-sm d-inline-flex align-items-center bg-white px-3 py-1 rounded border border-warning"
                            style={{ fontSize: "12px" }}
                          >
                            <i className="fa fa-calendar-check text-warning mr-2 font-size-xs"></i>
                            {new Date(parseInt(business.expiry)).toLocaleDateString()}
                          </span>
                        ) : (
                          <span className="text-muted font-weight-bold pl-1 font-size-sm">N/A</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* User Selection - Only for creation */}
              {!business?.id && (
                <div className="form-group row mb-6">
                  <div className="col-lg-12">
                    <label className="font-weight-bold">Select Owner User</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isLoading={loadingUsers}
                      isClearable={true}
                      isSearchable={true}
                      name="userid"
                      options={userOptions}
                      value={userOptions.find((opt) => opt.value === values.userid) || null}
                      onChange={(option) => {
                        const selectedUid = option ? option.value : "";
                        setFieldValue("userid", selectedUid);
                        if (option) {
                          const foundUser = users.find((u) => (u.userid || u.id) === selectedUid);
                          if (foundUser) {
                            if (foundUser.email) {
                              setFieldValue("business_email", foundUser.email);
                            }
                            if (foundUser.phone_number) {
                              setFieldValue("phone", foundUser.phone_number);
                            }
                            if (foundUser.name && (!values.name || values.name === "")) {
                              setFieldValue("name", foundUser.name);
                            }
                          }
                        }
                      }}
                      placeholder="Search and select owner user..."
                    />
                    {errors.userid && touched.userid ? (
                      <div className="text-danger mt-1">{errors.userid}</div>
                    ) : null}
                  </div>
                </div>
              )}
              <div className="form-group row">
                <div className="col-lg-4">
                  <label style={{ display: "grid", gridTemplateColumns: "85% 15%" }}>
                    <span>Name</span>
                    {(!superadmin) ?
                      <input className="m-auto" type="checkbox" defaultChecked={name_checkbox} onChange={() => setName_checkbox(!name_checkbox)} />
                      :
                      <></>
                    }
                  </label>

                  <Field
                    name="name"
                    component={Input}
                    placeholder="name"
                    style={{ borderColor: (superadmin && is_report && rep_name) ? "red" : "" }}
                  />

                </div>

                <div className="col-lg-4">
                  <label style={{ display: "grid", gridTemplateColumns: "85% 15%" }}>
                    <span>Phone</span>
                    {(!superadmin) ?
                      <input className="m-auto" type="checkbox" defaultChecked={phone_checkbox} onChange={() => setPhone_checkbox(!phone_checkbox)} />
                      :
                      <></>
                    }
                  </label>
                  <Field
                    name="phone"
                    component={Input}
                    placeholder="phone"
                    style={{ borderColor: (superadmin && is_report && rep_phone) ? "red" : "" }}
                  />
                </div>
                <div className="col-lg-4">
                  <label style={{ display: "grid", gridTemplateColumns: "85% 15%" }}>
                    <span>Short Description</span>
                    {
                      (!superadmin) ?
                        <input className="m-auto" type="checkbox" defaultChecked={tagline_checkbox} onChange={() => setTagline_checkbox(!tagline_checkbox)} />
                        :
                        <></>
                    }
                  </label>
                  <Field
                    name="tagline"
                    component={Input}
                    placeholder="tag line"
                    style={{ borderColor: (superadmin && is_report && rep_tagline) ? "red" : "" }}
                  />
                </div>

              </div>

              <div className="form-group row">
                <div className="col-lg-4">
                  <label style={{ display: "grid", gridTemplateColumns: "85% 15%" }}>
                    <span>Area code</span>
                    {
                      (!superadmin) ?
                        <input className="m-auto" type="checkbox" defaultChecked={area_code_checkbox} onChange={() => setAreaCode_checkbox(!area_code_checkbox)} />
                        :
                        <></>
                    }
                  </label>
                  <Field
                    name="area_code"
                    component={Input}
                    placeholder="area code"
                    style={{ borderColor: (superadmin && is_report && rep_areacode) ? "red" : "" }}
                  />
                </div>

                <div className="col-lg-4">
                  <label>Latitude</label>
                  <Field
                    name="latitude"
                    component={Input}
                    disabled={!superadmin}
                    placeholder="e.g. 31.5204"
                  />
                </div>

                <div className="col-lg-4">
                  <label>Longitude</label>
                  <Field
                    name="longitude"
                    component={Input}
                    disabled={!superadmin}
                    placeholder="e.g. 74.3587"
                  />
                </div>

              </div>

              {/* Show Exact Address & Coordinates Toggle */}
              <div className="form-group row mb-6">
                <div className="col-lg-12">
                  <div className="card bg-light-primary border-primary border-dashed p-4" style={{ borderRadius: "8px" }}>
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                      <div className="mr-3 mb-2 mb-md-0">
                        <h6 className="font-weight-bold text-dark mb-1">
                          <i className="fa fa-map-marker-alt text-primary mr-2"></i>
                          Show Exact Address & Coordinates Publicly
                        </h6>
                        <span className="text-muted font-size-sm">
                          {values.show_exact_address
                            ? "Enabled: Exact street address and coordinates (latitude/longitude) are publicly visible on the website and app."
                            : "Disabled: Only City and Country are displayed. Exact address and coordinates are hidden for privacy."}
                        </span>
                      </div>
                      <div className="d-flex align-items-center">
                        <span className={`label label-lg label-inline font-weight-bold mr-3 ${values.show_exact_address ? "label-light-success" : "label-light-danger"}`}>
                          {values.show_exact_address ? "Public Coordinates" : "Hidden Coordinates"}
                        </span>
                        <span className="switch switch-sm switch-icon switch-success">
                          <label className="mb-0">
                            <input
                              type="checkbox"
                              name="show_exact_address"
                              checked={Boolean(values.show_exact_address)}
                              onChange={(e) => setFieldValue("show_exact_address", e.target.checked)}
                            />
                            <span></span>
                          </label>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Address with Google Geocoding / Search */}
              <div className="card card-custom p-4 mb-6" style={{ backgroundColor: "#f8f9fa", border: "1px solid #ebedf3", borderRadius: "8px" }}>
                <div className="d-flex align-items-center mb-3">
                  <i className="fa fa-map-marked-alt text-primary mr-2 font-size-lg"></i>
                  <h6 className="font-weight-bold mb-0 text-dark">Address & Location Search (Google Geocoding)</h6>
                </div>
                <div className="form-group row mb-2">
                  <div className="col-lg-12">
                    <label className="font-weight-bold">Search Address on Google Maps to Auto-fill</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Type address, place, or landmark to search on Google..."
                        value={addressSearchText}
                        onChange={(e) => setAddressSearchText(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            handleAddressSearch();
                          }
                        }}
                      />
                      <div className="input-group-append">
                        <button
                          type="button"
                          className="btn btn-primary font-weight-bold"
                          disabled={isSearchingAddress || !addressSearchText.trim()}
                          onClick={() => handleAddressSearch()}
                        >
                          {isSearchingAddress ? (
                            <>
                              <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                              Searching...
                            </>
                          ) : (
                            <>
                              <i className="fa fa-search mr-1"></i> Search
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                    <span className="form-text text-muted font-size-xs">
                      Search address to automatically populate formatted address, latitude, and longitude.
                    </span>

                    {addressSearchError && (
                      <div className="alert alert-custom alert-light-danger fade show p-2 mt-2 mb-0" role="alert">
                        <div className="alert-text font-size-xs">{addressSearchError}</div>
                      </div>
                    )}

                    {addressSearchResults && addressSearchResults.length > 0 && (
                      <div className="list-group mt-2 border rounded shadow-xs" style={{ maxHeight: "220px", overflowY: "auto", backgroundColor: "#fff" }}>
                        <div className="list-group-item bg-light-primary text-primary font-weight-bold font-size-xs py-2">
                          Found {addressSearchResults.length} Google Location Result(s) - Click one to apply:
                        </div>
                        {addressSearchResults.map((item, idx) => (
                          <button
                            key={idx}
                            type="button"
                            className="list-group-item list-group-item-action py-2 text-left d-flex justify-content-between align-items-center"
                            onClick={() => {
                              setFieldValue("address", item.formatted_address || "");
                              if (item.latitude !== null && item.latitude !== undefined) {
                                setFieldValue("latitude", item.latitude);
                              }
                              if (item.longitude !== null && item.longitude !== undefined) {
                                setFieldValue("longitude", item.longitude);
                              }
                              if (item.postal_code && (!values.zip_code || values.zip_code === "")) {
                                setFieldValue("zip_code", item.postal_code);
                              }
                              if (item.country) {
                                const foundCountry = countries.find(
                                  (c) => c.name && c.name.toLowerCase() === item.country.toLowerCase()
                                );
                                if (foundCountry) {
                                  setFieldValue("country_id", foundCountry.id);
                                  citiesCrud.getCitiesByCountryId(foundCountry.id).then((cRes) => {
                                    if (cRes.data && cRes.data.data) {
                                      setCities(cRes.data.data);
                                      if (item.city) {
                                        const foundCity = cRes.data.data.find(
                                          (ct) => ct.name && ct.name.toLowerCase() === item.city.toLowerCase()
                                        );
                                        if (foundCity) {
                                          setFieldValue("city_id", foundCity.id);
                                        }
                                      }
                                    }
                                  }).catch(() => {});
                                }
                              }
                              setAddressSearchResults([]);
                            }}
                          >
                            <div>
                              <div className="font-weight-bold font-size-sm text-dark">{item.formatted_address}</div>
                              <div className="text-muted font-size-xs">
                                Lat: {item.latitude}, Lng: {item.longitude} {item.city ? `• City: ${item.city}` : ''} {item.country ? `• Country: ${item.country}` : ''}
                              </div>
                            </div>
                            <span className="badge badge-light-success font-weight-bold ml-2">Apply</span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="form-group row mb-0">
                  <div className="col-lg-8">
                    <label style={{ display: "grid", gridTemplateColumns: "85% 15%" }}>
                      <span>Address</span>
                      {(!superadmin) ? (
                        <input className="m-auto" type="checkbox" defaultChecked={address_checkbox} onChange={() => setAddress_checkbox(!address_checkbox)} />
                      ) : <></>}
                    </label>
                    <Field
                      name="address"
                      component={Input}
                      placeholder="e.g. 123 Main Street, Suite 400"
                      style={{ borderColor: (superadmin && is_report && rep_address) ? "red" : "" }}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label>Zip code</label>
                    <Field
                      name="zip_code"
                      disabled={!superadmin}
                      component={Input}
                      placeholder="e.g. 10001"
                    />
                  </div>
                </div>
              </div>

              {/* Social Media Links Section */}
              <div className="card card-custom p-4 mb-6" style={{ backgroundColor: "#fdfdfd", border: "1px solid #e1e3ea", borderRadius: "8px" }}>
                <div className="d-flex align-items-center mb-3">
                  <i className="fa fa-share-alt text-primary mr-2 font-size-lg"></i>
                  <h6 className="font-weight-bold mb-0 text-dark">Social Media & Online Presence</h6>
                </div>
                <div className="form-group row">
                  <div className="col-lg-4">
                    <label className="d-flex align-items-center">
                      <i className="fa fa-globe text-primary mr-2"></i> Website
                    </label>
                    <Field
                      name="website"
                      component={Input}
                      placeholder="https://example.com"
                    />
                  </div>
                  <div className="col-lg-4">
                    <label className="d-flex align-items-center">
                      <i className="fab fa-linkedin text-info mr-2"></i> LinkedIn
                    </label>
                    <Field
                      name="linkedin"
                      component={Input}
                      placeholder="https://linkedin.com/in/..."
                    />
                  </div>
                  <div className="col-lg-4">
                    <label style={{ display: "grid", gridTemplateColumns: "85% 15%" }}>
                      <span className="d-flex align-items-center">
                        <i className="fab fa-facebook text-primary mr-2"></i> Facebook
                      </span>
                      {(!superadmin) ? (
                        <input className="m-auto" type="checkbox" defaultChecked={facebook_checkbox} onChange={() => setFacebook_checkbox(!facebook_checkbox)} />
                      ) : <></>}
                    </label>
                    <Field
                      name="facebook"
                      component={Input}
                      placeholder="https://facebook.com/..."
                      style={{ borderColor: (superadmin && is_report && rep_facebook) ? "red" : "" }}
                    />
                  </div>
                </div>

                <div className="form-group row mb-0">
                  <div className="col-lg-4">
                    <label className="d-flex align-items-center">
                      <i className="fab fa-instagram text-danger mr-2"></i> Instagram
                    </label>
                    <Field
                      name="instagram"
                      component={Input}
                      placeholder="https://instagram.com/..."
                    />
                  </div>
                  <div className="col-lg-4">
                    <label className="d-flex align-items-center">
                      <i className="fab fa-tiktok text-dark mr-2"></i> TikTok
                    </label>
                    <Field
                      name="tiktok"
                      component={Input}
                      placeholder="https://tiktok.com/@..."
                    />
                  </div>
                  <div className="col-lg-4">
                    <label className="d-flex align-items-center">
                      <i className="fab fa-twitter text-info mr-2"></i> X (formerly Twitter)
                    </label>
                    <Field
                      name="x"
                      component={Input}
                      placeholder="https://x.com/..."
                    />
                  </div>
                </div>
              </div>

              <div className="form-group row">
                <div className="col-lg-4">
                  <label>Country</label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    name="country_id"
                    options={countryOptions}
                    value={countryOptions.find((opt) => opt.value === values.country_id) || null}
                    onChange={(option) => {
                      setFieldValue("country_id", option ? option.value : null);
                      setFieldValue("city_id", null); // reset city on country change
                      if (option) {
                        citiesCrud.getCitiesByCountryId(option.value).then(res => {
                          if (res.data && res.data.data) {
                            setCities(res.data.data);
                          }
                        }).catch(err => console.log(err));
                      } else {
                        setCities([]);
                      }
                    }}
                    placeholder="Select Country..."
                  />
                </div>
                <div className="col-lg-4">
                  <label>City</label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    name="city_id"
                    options={cityOptions}
                    value={cityOptions.find((opt) => opt.value === values.city_id) || null}
                    onChange={(option) => {
                      setFieldValue("city_id", option ? option.value : null);
                    }}
                    placeholder="Select City..."
                  />
                </div>
              </div>

              {/* Multiple Origins of Country & Spoken Languages */}
              <div className="form-group row">
                <div className="col-lg-6 mb-4">
                  <label className="font-weight-bold">
                    Origins of Country (Multiple Selection)
                  </label>
                  <Select
                    isMulti
                    className="basic-multi-select"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    options={countries.map(c => ({ value: c.name, label: c.name }))}
                    value={(selectedOriginCountries || []).map(item => ({ value: item, label: item }))}
                    onChange={(selected) => {
                      setSelectedOriginCountries(selected ? selected.map(s => s.value) : []);
                    }}
                    placeholder="Search & select origins of country (e.g. Pakistan, India, UK)..."
                  />
                  <span className="form-text text-muted font-size-xs">
                    Select countries representing the origin/heritage of the business.
                  </span>
                </div>
                <div className="col-lg-6 mb-4">
                  <label className="font-weight-bold">
                    Spoken / Supported Languages (Multiple Selection)
                  </label>
                  <Select
                    isMulti
                    className="basic-multi-select"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    options={STANDARD_LANGUAGES}
                    value={(selectedLanguages || []).map(lang => {
                      const found = STANDARD_LANGUAGES.find(sl => sl.value === lang);
                      return found || { value: lang, label: lang };
                    })}
                    onChange={(selected) => {
                      setSelectedLanguages(selected ? selected.map(s => s.value) : []);
                    }}
                    placeholder="Search & select spoken languages (e.g. English, Urdu, Arabic)..."
                  />
                  <span className="form-text text-muted font-size-xs">
                    Languages spoken by staff or supported for customer service.
                  </span>
                </div>
              </div>

              <div className="form-group row">
                <div className="col-lg-12">
                  <label style={{ display: "grid", gridTemplateColumns: "95% 5%" }}>
                    <span>Description / Product details</span>
                    {
                      (!superadmin) ?
                        <input className="m-auto" type="checkbox" defaultChecked={product_detail_checkbox} onChange={() => setProductDetail_checkbox(!product_detail_checkbox)} />
                        :
                        <></>
                    }
                  </label>
                  <Field
                    as="textarea"
                    rows={4}
                    name="product_details"
                    className="form-control"
                    placeholder="Enter full business description / product details..."
                    style={{ borderColor: (superadmin && is_report && rep_product_detail) ? "red" : "", resize: "vertical" }}
                  />
                </div>
              </div>

              <div className="form-group row">
                {(superadmin) ?
                  <div className="col-lg-4">
                    <label>Select Premium Status</label>
                    <select
                      className="form-control"
                      name="is_purchased"
                      value={purchasedvalue}
                      onChange={(e) => {
                        onPurchasedChange(e.target.value);
                      }}
                    >
                      <option value="false" >Free</option>
                      <option value="true" >Premium</option>
                    </select>
                  </div>
                  : <></>
                }
                <div className="col-lg-4">
                  <label>Business Email</label>
                  <Field
                    type="email"
                    name="business_email"
                    component={Input}
                    placeholder="Business Email"
                  />
                </div>
              </div>

              {(superadmin) && (
                <div className="form-group row">
                  <div className="col-lg-4">
                    <label>User Grace Period Start</label>
                    <Field
                      type="date"
                      name="user_grace_period_start"
                      component={Input}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label>User Grace Period End</label>
                    <Field
                      type="date"
                      name="user_grace_period_end"
                      component={Input}
                    />
                  </div>
                </div>
              )}

              <div className="form-group row border-top pt-4">
                <div className="col-lg-12 mb-3">
                  <h4>Categories</h4>
                </div>
                <div className="col-lg-12 mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="font-weight-bold mb-0">Categories</label>
                    {superadmin && (
                      <button
                        type="button"
                        className="btn btn-xs btn-light-primary font-weight-bold"
                        onClick={() => {
                          setCategoryModalInitialName("");
                          setShowAddCategoryModal(true);
                        }}
                      >
                        <i className="fa fa-plus mr-1"></i> Add New Category
                      </button>
                    )}
                  </div>
                  <CreatableSelect
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option: CheckboxOption }}
                    options={categoryOptions}
                    value={selectedCategoryOptions}
                    onChange={handleCategorySelectChange}
                    onCreateOption={(inputValue) => {
                      setCategoryModalInitialName(inputValue);
                      setShowAddCategoryModal(true);
                    }}
                    inputValue={categorySearchInput}
                    onInputChange={(val, { action }) => {
                      if (action === "input-change") {
                        setCategorySearchInput(val);
                      } else if (action === "menu-close") {
                        setCategorySearchInput("");
                      }
                    }}
                    isDisabled={!superadmin}
                    placeholder="Search or type a new category name (press Enter to create)..."
                    className="basic-multi-select"
                    classNamePrefix="select"
                    formatCreateLabel={(inputValue) => `+ Create new category "${inputValue}"...`}
                  />
                  <span className="form-text text-muted font-size-xs mt-1">
                    Select existing categories or click "Add New Category" to browse and create categories.
                  </span>
                </div>
                {/* 
                <div className="col-lg-6 mb-4">
                  <label className="font-weight-bold">Subcategories</label>
                  <Select
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option: CheckboxOption }}
                    options={availableSubcategories}
                    value={selectedSubcategoryOptions}
                    onChange={handleSubcategorySelectChange}
                    isDisabled={!superadmin || selectedCategories.length === 0}
                    placeholder={selectedCategories.length === 0 ? "Select Categories first" : "Select Subcategories"}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </div>
                */}
              </div>


              {((!superadmin) && (business.business_cover_images) && (business.business_images)) ?
                <>
                  <div className="form-group row mb-0"  >
                    <h4>Business Images</h4>
                  </div>
                  <div className="form-group row" id="image-div" >
                    <div className="col-lg-3">
                      <img className="business_image" onClick={event => imageModal(event, helper_funcs.get_signed_url(business.userid, business.logo))} src={helper_funcs.get_signed_url(business.userid, business.logo)} alt="image_icon" id="image" style={{ maxWidth: "200px", maxHeight: "200px", display: "block", padding: "0.5rem 0.1rem" }} />
                      <input className="m-auto" type="checkbox" defaultChecked={business_logo_image} onChange={() => setBusinessLogoImage_checkbox(!business_logo_image)} />
                    </div>

                    {business.business_images.map((item, index) => (
                      <div className="col-lg-3" key={index}>
                        <img className="business_image" name={`business_images[${index}].image`} onClick={event => imageModal(event, helper_funcs.get_signed_url(business.userid, item.image_url))} src={helper_funcs.get_signed_url(business.userid, item.image_url)} style={{ maxWidth: "200px", maxHeight: "200px", display: "block", padding: "1rem 0" }} alt="imagepath" />
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                          <input type="checkbox" onChange={() => call_report_image_array(item.id)} />
                          <input 
                            type="number" 
                            defaultValue={item.image_order || 0} 
                            onBlur={(e) => businessesCrud.updateImageOrder(item.id, e.target.value)} 
                            style={{ width: "60px", textAlign: "center" }} 
                            title="Image Order"
                          />
                        </div>
                      </div>
                    ))}

                    {business.business_cover_images.map((item, index) => (
                      <div className="col-lg-3" key={index}>
                        <img className="business_image" name={`business_cover_images[${index}].image`} onClick={event => imageModal(event, helper_funcs.get_signed_url(business.userid, item.image_url))} src={helper_funcs.get_signed_url(business.userid, item.image_url)} style={{ maxWidth: "200px", maxHeight: "200px", display: "block", padding: "1rem 0" }} alt="imagepath" />
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                          <input type="checkbox" onChange={() => call_report_image_array(item.id)} />
                          <input 
                            type="number" 
                            defaultValue={item.image_order || 0} 
                            onBlur={(e) => businessesCrud.updateImageOrder(item.id, e.target.value)} 
                            style={{ width: "60px", textAlign: "center" }} 
                            title="Image Order"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </>
                :
                <></>
              }
              <button
                type="submit"
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}
              ></button>
            </Form>

          </>
        )}
      </Formik>

      <AddCategoryModal
        show={showAddCategoryModal}
        onHide={() => setShowAddCategoryModal(false)}
        onCategoryCreated={handleCategoryFromModal}
        categories={allCategories}
        initialCategoryName={categoryModalInitialName}
        mode="business"
      />
    </>
  );
}
